import React from 'react';
import classnames from 'classnames';
import Timestamp from '../../../../Timestamp';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
import { getThumbGlobalClassNames } from '../../helpers';
const JournalThumbHtmlView = ({ deviation, width, height })=>/*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-header"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "daeditor-freeform-title"
    }, getDeviationTitle(deviation))), /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-body"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-date"
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime
    })), /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-text"
    }, deviation.textContent && deviation.textContent.excerpt)));
JournalThumbHtmlView.displayName = 'JournalThumbHtmlView';
export default JournalThumbHtmlView;

//# sourceMappingURL=JournalHtml.js.map